import { Oval } from 'react-loader-spinner';
import React from 'react';
import classNames from 'classnames';
import { Colors } from 'modules/theme';
import styles from './SectionLoader.module.scss';

const customStyles = (style, height) => {
  return {
    loader: {
      ...style,
      display: 'flex',
      justifyContent: 'center',
      minHeight: height,
      alignItems: 'center',
    },
  };
};

export default function SectionLoader({ height, style, className }) {
  const containerClasses = classNames(styles.container, className);

  return (
    <div
      style={customStyles(style, height).loader}
      className={containerClasses}
    >
      <Oval
        secondaryColor={Colors.darkBlue}
        color={Colors.darkBlue}
        width={30}
        height={30}
      />
    </div>
  );
}
